/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Detail_EventsInputs */

const es_chat_tool_detail_events = /** @type {(inputs: Chat_Tool_Detail_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} eventos`)
};

const en_chat_tool_detail_events = /** @type {(inputs: Chat_Tool_Detail_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

/**
* | output |
* | --- |
* | "{count} events" |
*
* @param {Chat_Tool_Detail_EventsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_events = /** @type {((inputs: Chat_Tool_Detail_EventsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_EventsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_events(inputs)
	return en_chat_tool_detail_events(inputs)
});
export { chat_tool_detail_events as "chat.tool_detail.events" }